

export const isDev = false
export function vuetifyConfiguration() {
  const options = {"defaults":{"font":{"family":"Inter"}},"blueprint":{},"ssr":true}
  
  
  
  
  return options
}

